import { render, staticRenderFns } from "./ContabilitaSoggettoListPage.vue?vue&type=template&id=4e35c1ca&scoped=true"
import script from "./ContabilitaSoggettoListPage.vue?vue&type=script&lang=js"
export * from "./ContabilitaSoggettoListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e35c1ca",
  null
  
)

export default component.exports